import { atom } from 'recoil';
import { ATOMS_KEYS } from '../atom-keys';

export const CurrentPageStore = atom<number>({
	key: ATOMS_KEYS.CURRENTPAGESTORE,
	default: 1,
});
